var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(this.el || this.tag,{tag:"component",class:[
    _vm.base.heading,
    _vm.colorPalette[_vm.color],
    _vm.scaleClass,
    _vm.type[_vm.weight],
    _vm.centered === true && _vm.type.centered
  ]},[_vm._t("default",[_vm._v("Add a heading!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }